module.exports = "/_next/static/images/water-utility-services-f87a19fd5fa75852c00e6e4386343609.webp";